import finalizeHandler from 'mocks/api/token/finalize';
import validateHandler from 'mocks/api/token/validate';
import verifyZipCodeHandler from 'mocks/api/token/verifyZipCode';

export default [
  ...finalizeHandler,
  ...validateHandler,
  ...verifyZipCodeHandler,
];
